var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticStyle:{"height":"60px"}},[_c('div',{staticClass:"card_new",class:{'highlightThis': _vm.highlightThis},on:{"click":function($event){return _vm.loadProject(_vm.source.projectID, 'projekte')}}},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.source.projectContent.stammdaten.allgemein.bv_name))])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }